<script setup lang="ts">
import type { FloorListVO } from '~/server/newhouse/interface'
import config from '~/common/config'

const props = defineProps<FloorListVO>()

// const Heart = 'https://imgf1.fccs.com.cn/newhouse-mobile/house_type/icon-heart.svg'
// const HeartO = 'https://imgf1.fccs.com.cn/newhouse-mobile/house_type/icon-heart-o.svg'
// props?.mobileAdUrl ||
const imgSrc = computed(() => props?.photo || config.DEFAULT_HOUSE_PIC)
// 跳转详情页★★★WZY★★★
</script>

<template>
  <a :href="getFloorIndexUrl(props?.floorId as number)" class="data-li" target="_blank">
    <div class="pic">
      <!--      <img src="https://pic.3gbizhi.com/uploadmark/20240523/fa3e4ed1a0e7e3ebd46351025bee359b.jpg" alt=""> -->
      <img :src="$getImageSize(imgSrc, 'c420x310')" alt="">
      <div class="desk-back" />
      <div class="address">
        <i class="iconfont icon-dingwei1" style="font-size: 14px;" />
        <!--        <EnvironmentFilled style="margin-right: 6px" /> -->
        {{ props?.address }}
      </div>
    </div>
    <div class="info">
      <div class="title">
        {{ props?.floor }}
        <span v-if="props?.areaName" class="area">[{{ props?.areaName }}]</span>
      </div>
      <div class="price">
        {{ props?.pricePrefix }} <span style="font-weight: bold;">{{ props?.price }}</span> {{ props?.priceSuffix }}
      </div>
      <div class="buildArea">
        {{ props?.houseModelInfo ? `${props?.houseModelInfo}   ` : null }}{{ (props?.modelAreaLow && props?.modelAreaHigh) ? `${props?.modelAreaLow}~${props?.modelAreaHigh}平米` : null }}
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.data-li {

  .pic {
    width: 210px;
    height: 155px;
    overflow: hidden;
    position: relative;
    border-radius: 5px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }

    .desk-back {
      position: absolute;
      width: 100%;
      height: 39px;
      bottom: 0;
      left: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 17%, rgba(0, 0, 0, 0.6) 100%);
      z-index: 1;
    }

    .address {
      color: #FFFFFF;
      font-size: 13px;
      font-weight: bold;
      margin-left: 9px;
      position: absolute;
      bottom: 9px;
      left: 0px;
      width: 180px;
      @include ell();
      z-index: 2;
    }
  }

  .info {
    margin-top: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
      width: 210px;
      @include ell();

      .area {
        font-size: 14px;
        font-weight: normal;
      }
    }
    .price {
      margin-top: 10px;
      font-size: 16px;
      color: #FF5B05;
    }
    .buildArea {
      margin-top: 10px;
      font-size: 14px;
      font-weight: normal;
      color: #767676;
    }
  }
}
</style>
